import loading from "./assets/loading.gif";
import styles from "./styles/style.module.scss";

const Loader = ({ full = false }) => {
    return (
        <section
            className={`${styles["loader"]} ${full ? styles["full-page"] : ""}`}
        >
            <img src={loading} alt="loading..." />
        </section>
    );
};

export default Loader;
